module.exports = __webpack_public_path__ + "images/category_lp/common/form-btn_a1876939ac831b753ebc05ac5ec1c595.png";